import React, { Fragment } from "react";
import { withRouter, Link } from "react-router-dom";
import { MemoryRouter, Route } from "react-router";
import Pagination from "@material-ui/lab/Pagination";
import PaginationItem from "@material-ui/lab/PaginationItem";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Drawer } from "@material-ui/core";
import {
  childCategories,
  subCategories,
  getProducts,
  childSubCategories,
} from "../../actions/categories";
import { getProductsByCategoryId } from "../../actions/products";
import { cartAdd } from "../../actions/cart";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StarRatings from "react-star-ratings";
import * as dropdowns from "../product/Dropdown";

import {
  CarouselProvider,
  DotGroup,
  ImageWithZoom,
  Slide,
  Slider,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataPerPage: 40,
      currentPage: 1,
      subCategory: null,
      childCategory: null,
      products: [],
      filterProducts: [],
      show: false,
      quickView: [],
      images: [],
      quantity: 1,
      affirm: [],
      colorFilter: [],
      priceFilter: [],
      heightFilter: [],
      widthFilter: [],
      finalFilters: [],

      color: "",
      width: 0,
      price: 0,
      height: 0,
    };
  }

  async componentDidMount() {
    const slug = window.location.toString().split("s/")[1];
    window.scrollTo(0, 0);
    // if (this.props.history.action === "POP") {
    //   this.props.history.goBack();
    // }
    this.fetchData(slug);
  }

  componentWillReceiveProps() {
    const slug = window.location.toString().split("s/")[1];
    this.fetchData(slug);
    if (
      this.props.match.params.slug !== window.location.toString().split("y/")[1]
    ) {
      window.scrollTo(0, 0);
      if (this.props.history.action === "POP") {
        this.props.history.goBack();
      }
    }
  }

  toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.type === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ rightSidebar: open });
  };

  fetchData = async (slug) => {
    const childSubCategories = await this.props.childSubCategories();

    childSubCategories.data.forEach(async (element) => {
      if (element.slug === slug) {
        await this.setState({ childSubCategory: element }, async () => {
          const subCategories = await this.props.subCategories();
          subCategories &&
            subCategories.data.forEach(async (_element) => {
              if (_element._id === element.categoryId) {
                await this.setState({ subCategory: _element });
                const childCategories = await this.props.childCategories();
                childCategories &&
                  childCategories.data.forEach(async (childElement) => {
                    if (_element.categoryId === childElement._id) {
                      await this.setState({ childCategory: childElement });

                      const products = await this.props.getProductsByCategoryId(
                        element._id
                      );
                      const productsArr = products;

                      await this.setState({ products: productsArr });
                      var height = [];
                      var width = [];
                      var color = [];
                      productsArr &&
                        productsArr.forEach((element) => {
                          if (element.height !== 0) {
                            height.push(element.height);
                          }
                          if (element.width !== 0) {
                            width.push(element.width);
                          }

                          element.attribute &&
                            element.attribute.forEach((elem) => {
                              if (JSON.parse(elem).color) {
                                color.push(JSON.parse(elem).color);
                              }
                            });

                          // colorFilter
                          // priceFilter
                          // heightFilter
                          // widthFilter
                        });
                      var colorFilter = color.filter(function (v, i, a) {
                        return a.indexOf(v) === i;
                      });
                      var heightFilter = height.filter(function (v, i, a) {
                        return a.indexOf(v) === i;
                      });
                      var widthFilter = width.filter(function (v, i, a) {
                        return a.indexOf(v) === i;
                      });
                      this.setState({
                        widthFilter: widthFilter,
                        heightFilter: heightFilter,
                        colorFilter: colorFilter,
                      });
                      this.setState({ filterProducts: productsArr });
                    }
                  });
              }
            });
        });
      }
    });

    // console.log(this.state);
  };
  _getUnique = async (array) => {
    var seen = {};
    var check = array.filter(function (item) {
      return seen.hasOwnProperty(item) ? false : (seen[item] = true);
    });
    return check;
  };
  _addToWishlist = async (item) => {
    const wishlistData = localStorage.getItem("wishlist");
    if (wishlistData && wishlistData.length > 0) {
      const arr = JSON.parse(wishlistData);
      var a = true;
      arr.forEach((e, index) => {
        if (e._id === item._id) {
          a = false;
          arr.splice(index, 1);
          toast(`Product removed from wishlist`, { containerId: "B" });
        }
      });
      if (a === true) {
        arr.push(item);
      }
      localStorage.setItem("wishlist", JSON.stringify(arr));
    } else {
      localStorage.setItem("wishlist", JSON.stringify([item]));
    }
    if (a !== false) {
      this.setState({ show: false });
      toast(`Product added to wishlist`, { containerId: "B" });
    }
  };

  _addToCart = async (item) => {
    // console.log(item);

    const data = {
      item: item,
      quantity: this.state.quantity,
    };
    const cartAdd = await this.props.cartAdd(data);
    if (cartAdd) {
      this.setState({
        show: false,
        quantity: 1,
      });
      toast(`Product added in cart`, { containerId: "B" });
    }
  };
  handleClose = () => {
    this.setState({ show: false, quantity: 1 });
  };
  handleShow = () => {
    this.setState({ show: true, quantity: 1 });
  };
  _openModal = async (e, item) => {
    e.preventDefault();
    // const productsArr = [];
    // item &&
    //   item.forEach(async __element => {
    //     productsArr.push(__element);
    //   });
    // console.log("product array ", item);
    await this.setState({ quickView: item });
    const images = [];
    item.images.forEach((e) => {
      images.push({
        original: e,
        thumbnail: e,
      });
    });
    this.setState({ images: images });

    this.setState({ show: true });
  };
  _filterProductsHeight = async (height) => {
    var filterArray = [];

    this.state.products &&
      this.state.products.forEach((element) => {
        if (height && height === element.height) {
          filterArray.push(element);
        }
      });
    this.setState({ filterProducts: filterArray });
  };
  _filterProductsWidth = async (width) => {
    var filterArray = [];

    this.state.products &&
      this.state.products.forEach((element) => {
        if (width && width === element.width) {
          filterArray.push(element);
        }
      });
    this.setState({ filterProducts: filterArray });
  };
  _filterProductsColor = async (color) => {
    var filterArray = [];

    this.state.products &&
      this.state.products.forEach((element) => {
        element.attribute &&
          element.attribute.forEach((elem) => {
            if (JSON.parse(elem).color === color) {
              filterArray.push(element);
            }
          });
      });
    this.setState({ filterProducts: filterArray });
  };
  _filterProductsPrice = async (min, max) => {
    var filterArray = [];

    this.state.products &&
      this.state.products.forEach((element) => {
        if (min < element.price && max > element.price) {
          filterArray.push(element);
        }
      });
    this.setState({ filterProducts: filterArray });
  };
  handleClick = (event) => {
    this.setState({
      currentPage: Number(event.page),
    });
  };
  render() {
    const { quickView } = this.state;

    const { filterProducts, currentPage, dataPerPage } = this.state;

    // Logic for displaying todos
    const indexOfLastTodo = currentPage * dataPerPage;
    const indexOfFirstTodo = indexOfLastTodo - dataPerPage;
    const currentTodos =
      filterProducts && filterProducts.slice(indexOfFirstTodo, indexOfLastTodo);
    // console.log("currentTodos: ", currentTodos);
    const renderTodos =
      currentTodos &&
      currentTodos.map((item, index) => {
        return (
          <div
            key={index}
            className="col-md-3 my-3 col-sm-6 col-12 borderBottom-1"
          >
            <div className="product-cards">
              <Link to={`/product/${item.slug}`}>
                <div className="product-cards-img">
                  <div
                    style={{
                      backgroundImage: `url(${item.images[0]})`,
                      backgroundSize: "contain",
                      height: "100%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  ></div>
                  {/* <img src={`${item.images[0]}`} width="100%" alt="" /> */}
                </div>
                <div className="card-inner-area">
                  <span className="sale-sticker">Sale</span>
                  <span
                    className="sale-wish"
                    onClick={(e) => {
                      e.preventDefault();
                      this._addToWishlist(item && item);
                    }}
                  >
                    <i className="far fa-heart" />
                  </span>
                  <div className="quick-view-btn">
                    <Link to={"!#"} onClick={(e) => this._openModal(e, item)}>
                      <span>Quickview</span>
                    </Link>
                  </div>
                </div>
              </Link>{" "}
              <div className="product-cards-content">
                <div className="product-cards-txt">
                  <Link to={`/product/${item.slug}`}>{item && item.title}</Link>
                  <div className="product-cards-price">
                    <span>
                      $
                      {item.enableSale === true
                        ? Number(
                            item.price - (item.price * item.saleDiscount) / 100
                          ).toFixed(2)
                        : Number(item.price).toFixed(2)}
                    </span>
                    <span>
                      {item.enableSale === true ? (
                        <del>${Number(item.price).toFixed(2)}</del>
                      ) : null}
                    </span>
                  </div>
                  <div className="product-cards-rating">
                    <ul className="product-rating">
                      <StarRatings
                        rating={
                          item.reviews ? item.reviews / item.reviewCount : 0
                        }
                        starDimension="20px"
                        starSpacing="2px"
                        starRatedColor="gold"
                      />
                      <span>{item.reviewCount}</span>
                    </ul>
                    <span className="affirm-text ">
                      <p
                        className="affirm-as-low-as"
                        data-page-type="category"
                        data-amount={`${item && item.price * 100}`}
                      ></p>
                    </span>

                    <span>
                      {item.price > 49 ? <b>Free Shipping</b> : <b></b>}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      });

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (
      let i = 1;
      i <= Math.ceil(filterProducts && filterProducts.length / dataPerPage);
      i++
    ) {
      pageNumbers.push(i);
    }

    // const renderPageNumbers = pageNumbers.map((number) => {
    //   return (
    //     <ul style={{ display: "inline-block" }}>
    //       <li
    //         className={number === this.state.currentPage ? "active" : ""}
    //         key={number}
    //         id={number}
    //         style={{ listStyle: "none" }}
    //       >
    //         {/* {number === this.state.currentPage ? ( */}
    //         <button
    //           id={number}
    //           className="btn btn-primary pagi-button"
    //           onClick={this.handleClick}
    //         >
    //           {number}
    //         </button>
    //       </li>
    //     </ul>
    //   );
    // });

    return (
      <Fragment>
        <ToastContainer
          enableMultiContainer
          containerId={"B"}
          position={toast.POSITION.TOP_RIGHT}
        />
        {/* PRODUCTS BODY */}
        <div className="products-page wrapper-90 max-1600">
          <Breadcrumb
            title={`${
              this.state.childCategory && this.state.childCategory.name
            } / ${this.state.subCategory && this.state.subCategory.name} / ${
              this.state.childSubCategory && this.state.childSubCategory.name
            }`}
          />
          <div className="product-heading">
            <h2>
              {this.state.childSubCategory && this.state.childSubCategory.name}
            </h2>
          </div>
          <div className="products-body">
            <div className="container-fluid px-0">
              {/* DROP DOWN links */}
              <div className="products-dropdown-links">
                <ul className="products-dropdown-list">
                  {/* PILE HEIGHT DROPDOWN */}
                  {this.state.finalFilters.map((item) => (
                    <li className="p-2 dropdown-titles">
                      <span className="p-2">{item.title}</span>
                      <i className="fa fa-angle-down" />

                      <ul className="products-dropdown-innerlist">
                        <div>
                          <div className="filter-design-sections">
                            {item.children &&
                              item.children.imageFilters.map((item1, index) => (
                                <li
                                  className="design-selection-item m-0"
                                  key={index}
                                >
                                  <div className="select-to-filter-item">
                                    <ToggleButtonGroup
                                      value={this.state.selectedFilters}
                                      onChange={this.handleSelectedFilters}
                                    >
                                      <ToggleButton
                                        value={`${item1.title}`}
                                        aria-label={`${item1.title}`}
                                      >
                                        <img
                                          src={item1.image}
                                          className="img-fluid w-100"
                                          alt=""
                                        />

                                        <p>{item1.title}</p>
                                      </ToggleButton>
                                    </ToggleButtonGroup>
                                  </div>
                                </li>
                              ))}
                          </div>
                        </div>
                        {item.children &&
                          item.children.nonImageFilters.map((item1, index) => (
                            <div className="d-flex align-items-center flex-row-reverse">
                              <li key={index} className="inputLable-hovered f1">
                                <ToggleButtonGroup
                                  value={this.state.selectedFilters}
                                  onChange={this.handleSelectedFilters}
                                >
                                  <ToggleButton
                                    value={`${item1.title}`}
                                    aria-label={`${item1.title}`}
                                    className="w-100"
                                  >
                                    <label
                                      className="m-0 w-100 c-pointer"
                                      htmlFor={`filterSelect${index}`}
                                    >
                                      <p>{item1.title}</p>
                                    </label>
                                  </ToggleButton>
                                </ToggleButtonGroup>
                              </li>
                              <div className="p-2 filter-input">
                                <input
                                  type="checkbox"
                                  id={`filterSelect${index}`}
                                />
                              </div>
                            </div>
                          ))}
                      </ul>
                    </li>
                  ))}

                  {/*END PILE HEIGHT DROPDOWN */}
                  {/* PRICE PER PRODUCT DROPDOWN */}

                  {/*END PRICE PER PRODUCT DROPDOWN */}
                  {/*RUG SHAPE DROPDOWN */}

                  <li
                    className="dropdown-titles call-us-btn"
                    style={{ width: "150px", textAlign: "center" }}
                    onClick={() =>
                      this.setState({ filterProducts: this.state.products })
                    }
                  >
                    Clear Filter
                  </li>

                  <li
                    className="sort-filter-btn d-flex align-items-center p-2"
                    onClick={this.toggleDrawer("anchor", true)}
                  >
                    <span>Sort & Filter</span>
                  </li>

                  <Drawer
                    anchor={"right"}
                    open={this.state.rightSidebar}
                    onClose={this.toggleDrawer("right", false)}
                  >
                    <div className="productFilterSidebar">
                      <div className="sidebar-header">
                        <div
                          title="close"
                          className="closeSidebar"
                          onClick={this.toggleDrawer("right", false)}
                        >
                          <button type="button" className="close-sidebar-btn">
                            <svg
                              focusable="false"
                              viewBox="0 0 28 28"
                              class="closeSide-icon"
                              aria-hidden="true"
                              data-hb-id="pl-icon"
                            >
                              <path d="M15.4 14l3.3-3.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L14 12.6l-3.3-3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.3 3.3-3.3 3.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l3.3-3.3 3.3 3.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L15.4 14z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="sidebar-header-text">
                          <span>Sort & Filtre</span>
                        </div>
                      </div>
                      <div className="sidebarBody-inner">
                        <dropdowns.Dropdown
                          dropdownLable="Weights & Dimensions"
                          dropdownSubtitle={this.state.subTitle}
                        >
                          <div className="filter-dropDown-body">
                            Lorem ipsum dolor sit, amet consectetur adipisicing
                            elit. Facere nobis officiis odio!
                          </div>
                        </dropdowns.Dropdown>
                      </div>
                    </div>
                  </Drawer>

                  {/*END Rug Shape DROPDOWN  */}
                </ul>
              </div>
              {/* END DROP DOWN links */}
              {/* END filter side bar */}
              <div className="products-items">
                {/* FIRST ROW */}
                <div className="row">{renderTodos}</div>
                <div className="container text-center">
                  <MemoryRouter initialEntries={["/inbox"]} initialIndex={0}>
                    <Route>
                      {({ location }) => {
                        return (
                          <Pagination
                            page={
                              this.state.currentPage && this.state.currentPage
                            }
                            count={pageNumbers && pageNumbers.length}
                            renderItem={(item) => (
                              <PaginationItem
                                {...item}
                                onClick={(e) => this.handleClick(item)}
                              />
                            )}
                          />
                        );
                      }}
                    </Route>
                  </MemoryRouter>
                </div>
              </div>
              {/*product item*/}
            </div>
            {/*Container fluid*/}
          </div>
          {/*product body*/}
        </div>
        {/*products-page*/}

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          animation={false}
          style={{ marginTop: "2%", boxShadow: "none" }}
        >
          <Modal.Body>
            {this.state.show && this.state.show === true && quickView ? (
              <div className="container-fluid">
                <div className="row">
                  <div
                    className="modal-close"
                    onClick={this.handleClose}
                    data-dismiss="modal"
                  >
                    <span closeButton>×</span>
                  </div>
                  <div className="col-md-6">
                    <div className="modal-left-side">
                      <div className="moda-left-heading">
                        <h2>{quickView && quickView.title}</h2>
                      </div>
                      <div className="modal-seemore">
                        See More from{" "}
                        <a href="#">{this.state.brand && this.state.brand}</a>
                        Shop
                      </div>
                      <div className="modal-reviews">
                        <ul id="modal-stars">
                          <StarRatings
                            rating={
                              quickView && quickView.reviews
                                ? quickView.reviews / quickView.reviewCount
                                : 0
                            }
                            starDimension="20px"
                            starSpacing="2px"
                            starRatedColor="gold"
                          />
                          <span>{quickView && quickView.reviewCount}</span>
                        </ul>
                      </div>
                      <div className="modal-slider">
                        <CarouselProvider
                          visibleSlides={1}
                          totalSlides={quickView && quickView.images.length}
                          step={1}
                          naturalSlideWidth={400}
                          naturalSlideHeight={400}
                          hasMasterSpinner
                        >
                          <Slider>
                            {quickView &&
                              quickView.images &&
                              quickView.images.map((item, index) => (
                                <Slide index={index}>
                                  <ImageWithZoom src={item} />
                                </Slide>
                              ))}
                          </Slider>

                          <DotGroup />
                        </CarouselProvider>
                      </div>
                    </div>{" "}
                    {/*END MODAL LEFT SIDE*/}
                  </div>
                  <div
                    className="col-md-6"
                    style={{ backgroundColor: "hsla(240,5%,96%,.85)" }}
                  >
                    <div className="moda-right-side">
                      <div className="modal-right-price">
                        <span className="m-price">
                          $
                          {quickView.enableSale === true
                            ? Number(
                                quickView.price -
                                  (quickView.price * quickView.saleDiscount) /
                                    100
                              ).toFixed(2) * this.state.quantity
                            : Number(quickView.price).toFixed(2) *
                              this.state.quantity}
                        </span>
                        <span>
                          {quickView.enableSale === true ? (
                            <del className="moda-right-price-off">
                              ${Number(quickView.price).toFixed(2)}
                            </del>
                          ) : null}
                        </span>
                      </div>
                      <div className="modal-shiping-dete">
                        <span>FREE Shipping</span>
                        <span>Get it Now</span>
                      </div>

                      <div className="modal-right-collapse">
                        <div className="accordion" id="accordion">
                          <div className="card mt-3">
                            <div className="checkout-inps">
                              <span className="selectcountry-hint">
                                Select Quantity
                              </span>
                              <select
                                className="countrySelect"
                                onChange={(e) => {
                                  this.setState({
                                    quantity: e.target.value,
                                  });
                                }}
                              >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                              </select>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-description"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#description-collapse"
                                aria-expanded="false"
                                aria-controls="description-collapse"
                              >
                                Description
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="description-collapse"
                              className="collapse"
                              aria-labelledby="product1description"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="description-body">
                                  <div className="description-content">
                                    <p>{quickView && quickView.description}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-weights-dimention"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#weights-dimention-collapse"
                                aria-expanded="false"
                                aria-controls="weights-dimention-collapse"
                              >
                                Weights & Dimensions
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="weights-dimention-collapse"
                              className="collapse"
                              aria-labelledby="product1weights-dimention"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="weights-dimension-content">
                                  {quickView &&
                                    quickView.weightAndDimension &&
                                    quickView.weightAndDimension.weightAndDimension.map(
                                      (e, index) => (
                                        <Fragment key={index}>
                                          <p className="dimension-heading">
                                            {JSON.parse(e).name}
                                          </p>
                                          <div className="product-weight">
                                            <div className="overall-weight">
                                              <p className="m-0 py-2">
                                                {JSON.parse(e).name}
                                              </p>
                                            </div>
                                            <p className="m-0 py-2">
                                              {JSON.parse(e).value}
                                            </p>
                                          </div>
                                        </Fragment>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mt-3">
                            <div
                              id="product-spesification"
                              className="collapse-heading"
                            >
                              <button
                                className="btn btn-link collapsed py-md-3"
                                type="button"
                                data-toggle="collapse"
                                data-target="#spesification-collapse"
                                aria-expanded="false"
                                aria-controls="spesification-collapse"
                              >
                                Specifications
                                <span>
                                  <i className="fa fa-angle-down" />
                                </span>
                              </button>
                            </div>
                            <div
                              id="spesification-collapse"
                              className="collapse"
                              aria-labelledby="product1spesification"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <div className="spesification-content">
                                  {quickView &&
                                    quickView.specification &&
                                    quickView.specification.specification.map(
                                      (e, index) => (
                                        <div
                                          key={index}
                                          className="product-weight"
                                        >
                                          <div className="overall-weight">
                                            <p className="m-0 py-2">
                                              {JSON.parse(e).name}
                                            </p>
                                          </div>
                                          <p className="m-0 py-2">
                                            {JSON.parse(e).value}
                                          </p>
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="modal-end-btns">
                            <button
                              type="button"
                              className="modal-add-cart"
                              onClick={(e) => {
                                e.preventDefault();
                                this._addToCart(quickView && quickView);
                              }}
                            >
                              <span>Add To Cart</span>
                            </button>
                            <button
                              type="button"
                              className="modal-save-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                this._addToWishlist(quickView && quickView);
                              }}
                            >
                              <span>
                                <i className="far fa-heart" /> Save
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              "<div></div>"
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

getProductsByCategoryId.propTypes = {
  getProductsByCategoryId: PropTypes.func.isRequired,
};
subCategories.propTypes = {
  subCategories: PropTypes.func.isRequired,
};
childCategories.propTypes = {
  childCategories: PropTypes.func.isRequired,
};
childSubCategories.propTypes = {
  childSubCategories: PropTypes.func.isRequired,
};
cartAdd.propTypes = {
  cartAdd: PropTypes.func.isRequired,
};

export default withRouter(
  connect(null, {
    childCategories,
    subCategories,
    childSubCategories,
    getProductsByCategoryId,
    cartAdd,
  })(Index)
);
